import { pages } from '@constants/pages';
import { Link } from 'react-router';

interface IProps {
  isAuth?: boolean;
}

export function Footer({ isAuth = true }: IProps) {
  return (
    <footer className="w-full border-t">
      <nav className="mx-auto flex max-w-screen-xl flex-col items-center space-y-6 px-4 pb-6 pt-4 md:px-10">
        <div className="flex w-full flex-row justify-between gap-x-6 sm:justify-center lg:gap-x-12">
          <div className="grid grid-cols-1 justify-center gap-x-6 sm:grid-cols-[repeat(2,_auto)] lg:grid-cols-[repeat(4,_auto)] lg:gap-x-12">
            <Link
              className="text-foreground after:bg-foreground inline-block text-sm after:block after:h-px after:w-0 after:transition-all after:duration-300 after:content-[''] hover:after:w-full lg:text-base"
              target="_blank"
              to={pages.terms}>
              Termos e condições de uso
            </Link>
            <Link
              className="text-foreground after:bg-foreground inline-block text-sm after:block after:h-px after:w-0 after:transition-all after:duration-300 after:content-[''] hover:after:w-full lg:text-base"
              target="_blank"
              to={pages.privacyPolicies}>
              Política de privacidade
            </Link>
            <a
              className="text-foreground after:bg-foreground inline-block text-sm after:block after:h-px after:w-0 after:transition-all after:duration-300 after:content-[''] hover:after:w-full lg:text-base"
              href="mailto:contato@oguiadeprescricao.com.br">
              Contato
            </a>
            {isAuth && (
              <Link
                className="text-foreground after:bg-foreground inline-block text-sm after:block after:h-px after:w-0 after:transition-all after:duration-300 after:content-[''] hover:after:w-full lg:text-base"
                to={pages.suggestTopic}>
                Sugerir tema
              </Link>
            )}
          </div>
          <div className="flex flex-row gap-4 lg:gap-6">
            <a
              href="https://www.instagram.com/oguiadeprescricao/"
              target="_blank"
              title="Instagram">
              <img
                alt="Instagram logo"
                height="26"
                src="https://cdn.simpleicons.org/instagram"
                width="26"
              />
            </a>
            <a
              href="https://www.facebook.com/oguiadeprescricao?locale=pt_BR"
              target="_blank"
              title="Facebook">
              <img
                alt="Facebook logo"
                height="26"
                src="https://cdn.simpleicons.org/facebook"
                width="26"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=br.com.gpmed.app&hl=pt_BR"
              target="_blank"
              title="Google Play">
              <img
                alt="Google play logo"
                height="26"
                src="https://cdn.simpleicons.org/googleplay"
                width="26"
              />
            </a>
            <a
              href="https://apps.apple.com/br/app/gpmed/id6476676703"
              target="_blank"
              title="App Store">
              <img
                alt="App store logo"
                height="26"
                src="https://cdn.simpleicons.org/appstore"
                width="26"
              />
            </a>
          </div>
        </div>
        <p className="text-foreground text-xs">
          Copyright © 2025 GPMED - Todos os direitos reservados
        </p>
      </nav>
    </footer>
  );
}
